import { Radio } from 'lucide-react';
import { channelIsActive, type ChannexChannelResource, type PropertyResponse } from '@/shared/api';
import { cn } from '@/shared/lib/cn';
import { OtaLogo, getOtaLabel } from '../OtaLogo';
import { BentoTile } from './BentoTile';

interface ChannelsTileProps {
  property: PropertyResponse;
  mappedChannels: ChannexChannelResource[];
  liveChannels: ChannexChannelResource[];
}

export function ChannelsTile({ property, mappedChannels, liveChannels }: ChannelsTileProps) {
  return (
    <BentoTile
      to="/properties/$id/channels"
      propertyId={property.id}
      icon={<Radio size={13} strokeWidth={2} />}
      eyebrow={
        mappedChannels.length > 0
          ? `Kanäle · ${liveChannels.length} von ${mappedChannels.length} aktiv`
          : 'Kanäle'
      }
      cta="Kanäle verwalten"
      iconTint="sealwax"
    >
      {!property.channexUnitPublished ? (
        <p className="text-ink-faint text-sm">
          Dieses Apartment ist beim Kanalmanager noch nicht veröffentlicht — die Kanäle des Objekts
          verkaufen es deshalb nicht.
        </p>
      ) : mappedChannels.length === 0 ? (
        <p className="text-ink-faint text-sm">
          Der Kanalmanager ist bereit, es ist aber noch kein Buchungsportal verbunden.
        </p>
      ) : (
        <ul className="flex flex-col gap-2.5">
          {mappedChannels.map((c) => {
            const active = channelIsActive(c);
            return (
              <li key={c.id} className="flex items-center gap-2.5">
                <OtaLogo channel={c.attributes.channel} active={active} size={20} />
                <span className="text-ink text-sm">{getOtaLabel(c.attributes.channel)}</span>
                <span
                  className={cn(
                    'ml-auto inline-flex items-center gap-1 text-xs font-medium',
                    active ? 'text-sage' : 'text-ink-faint',
                  )}
                >
                  {active && <span className="bg-sage size-1.5 rounded-full" aria-hidden />}
                  {active ? 'Aktiv' : 'Zuordnung offen'}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </BentoTile>
  );
}
